import React, { useEffect, useState } from 'react'
import CollapsibleCard from '../../components/CollapsibleCard'
import { Col, Row, FormGroup, Input } from 'reactstrap'

function MatriculateRequestFilters(props) {

  const { changeFilter, currentOptions } = props
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    let newIsOpen = currentOptions.state_id && currentOptions.state_id !== 'any'
    newIsOpen = newIsOpen && currentOptions.type && currentOptions.type !== 'any'

    setIsOpen(newIsOpen);
  }, [currentOptions.state_id, currentOptions.type])

  return (
    <CollapsibleCard title="Filtros" open={ isOpen }>
      <Row>
        <Col sm={4}>
          <FormGroup>
            <label>Tipo de Solicitud</label>
            <Input
              type="select"
              onChange={ (event) => changeFilter('type', event.target.value) }
              value={ currentOptions?.type ? currentOptions.type : 'any' }
            >
              <option value="any">Todas</option>
              <option value="account">Cuenta Web</option>
              <option value="perfil">Cuenta APP</option>
              <option value="foto">Foto APP</option>
              <option value="matricula">Matriculación</option>
              <option value="rematriculacion">Rematriculación</option>
              <option value="cancelation">Cancelación Mat.</option>
              <option value="suspension">Suspensión Mat.</option>
              <option value="facturacion_ooss">Facturación OOSS</option>
              <option value="forma_pago">Forma de Pago</option>
              <option value="consultorio">Consultorio</option>
              <option value="consultorio_baja">Baja Consultorio</option>
              <option value="consultorio_renovacion">Renovación Consultorio</option>
              <option value="consultorio_update">Modificación Consultorio</option>
              <option value="staff_multiple">Staff Múltiple</option>
              <option value="staff">Alta Staff</option>
              <option value="staff_baja">Baja Staff</option>
            </Input>
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <label>Estado</label>
            <Input
              type="select"
              onChange={ (event) => changeFilter('state_id', event.target.value) }
              value={ currentOptions?.state_id ? currentOptions.state_id : 'any' }
            >
              <option value="any">Todas</option>
              <option value="1">Solicitada</option>
              <option value="2">Aceptada</option>
              <option value="3">Rechazada</option>
              {/* Estados de consultorios */}
              <option value="4">Enviado a Inspección</option>
              <option value="5">Enviado Ministerio</option>
              <option value="6">En Corrección</option>
              <option value="7">Habilitado/Finalizado</option>
            </Input>
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <label>Matrícula</label>
            <Input
              type="number"
              onChange={ (event) => changeFilter('search', event.target.value.trim()) }
              value={ currentOptions?.search ? currentOptions.search : '' }
            />
          </FormGroup>
        </Col>
      </Row>
    </CollapsibleCard>
  )
}

export default MatriculateRequestFilters
